import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { formatDate } from "../components/DateFormatServices";
import APIService from "../components/postServices";
import { showToast } from "../components/toastServices";
import PublicHeader from "../components/header";
import { RadioButton } from "primereact/radiobutton";

function PaymentForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ApplicationData, setApplicationData] = useState(null);
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data;

    if (data) {
      setApplicationData(data);
    } else {
      navigate("/");
    }
  }, [location.state, navigate, ApplicationData]);
  // console.log("PaymentForm", ApplicationData);

  const [CCAvenuePaymentSetup, setCCAvenuePaymentSetup] = useState();

  useEffect(() => {
    APIService.get(`/CCAvenuePayment/CCAvenuePaymentSetup`)
      .then((response) => {
        setCCAvenuePaymentSetup(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);

  const [paymentFormData, setPaymentFormData] = useState({});

  useEffect(() => {
    ApplicationData &&
      setPaymentFormData({
        studentNo: ApplicationData && ApplicationData.tokenApiDto.studentNo,
        class: ApplicationData && ApplicationData.tokenApiDto.class,
        section: ApplicationData && ApplicationData.tokenApiDto.section,
        mobile: ApplicationData && ApplicationData.tokenApiDto.mobile,
        email: ApplicationData && ApplicationData.tokenApiDto.email,
        dob: ApplicationData && ApplicationData.tokenApiDto.dob,
        // parentName: ApplicationData.tokenApiDto.parentName,
        // relation: ApplicationData.tokenApiDto.relation,
        amount: 0,
        paymentOption: "",
      });
  }, [ApplicationData]);
  const [error, setError] = useState({});

  const [amountError, setAmountError] = useState("");
  const [paymentOptionError, setPaymentOptionError] = useState("");

  const PaymentFormDataChange = (event) => {
    const { name, value } = event.target;

    // Update the form state with the new value
    setPaymentFormData({
      ...paymentFormData,
      [name]: value,
    });
  };

  // const setPaymentFormData = (error, input) => {
  //   setAmountError(error);
  //   setError(true);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let amount = paymentFormData.amount;
    let paymentOption = paymentFormData.paymentOption;

    if (amount === 0 || amount === "0" || amount === "") {
      setAmountError("Please input Amount");
      setError(true);
      isValid = false;
    }
    if (!paymentOption) {
      setPaymentOptionError("Please select payment option");
      isValid = false;
    }

    if (isValid) {
      try {
        const response = await APIService.Post(
          `/CCAvenuePayment/quickPaymentInitiate`,
          paymentFormData
        );
        console.log("response", response);
        if (response.responseCode === 1) {
          // initiateTransaction(response.dataSet);
          // Navigate to the new location ("/Payonline") and replace the current entry in the history
          // navigate("/Payment", { state: { data: "/" }, replace: true });
          navigate("/Payment", {
            state: {
              data: response.dataSet,
              link: "/",
              status: "payment",
            },
            replace: true,
          });
          setApplicationData(null);
          // setPaymentFormData({});
        }
      } catch (error) {
        // showToast("error", error.response.data.responseMessage);
      }
    }
  };

  const breadcrumb = [{ label: "Online Payment", url: "/" }];

  return (
    <div className="main-page">
      <div>
        {" "}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <PublicHeader breadcrumb={breadcrumb} title={"Online Payment"} />
        <div className="content-wrapper  mt-10">
          <div className="col-md-12">
            <h3 className="text-center">
              Make Online Payment
              {/* <small>Make payment and submit the application form</small> */}
            </h3>

            <div className=" reg">
              <div className="box-header text-center">
                <h3 className="box-title">Information</h3>
              </div>
              <div className="box-body" style={{ padding: "0 15%" }}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Student Name :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.studentName}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Student No :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData &&
                          ApplicationData.tokenApiDto.studentNo}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Date of Birth :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {formatDate(
                          ApplicationData && ApplicationData.tokenApiDto.dob
                        )}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Class :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.class}-
                        {ApplicationData && ApplicationData.tokenApiDto.section}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Mobile :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.mobile}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Email :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.email}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                       style={{ fontWeight: "400" }}
                      >
                        Reference No :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData.referenceNo}
                      </label>
                    </div> */}
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Total Amount Due:
                        <br />
                        <small style={{ fontWeight: "400" }}>
                          (as on{" "}
                          {formatDate(
                            ApplicationData && ApplicationData.endDate
                          )}
                          )
                        </small>
                      </label>
                      <label className="col-md-8 col-form-label">
                        {/* INR {ApplicationCost} */}
                        INR{" "}
                        {ApplicationData && ApplicationData.totalFeeDueAmount}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        // style={{ fontWeight: "400" }}
                      >
                        Amount
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                        :
                      </label>
                      <input
                        type="numeric"
                        className="form-control form-control-sm"
                        placeholder="Amount"
                        id="amount"
                        name="amount"
                        value={paymentFormData.amount}
                        onChange={PaymentFormDataChange}
                        onFocus={() => setAmountError("")}
                      />
                      {error && amountError && (
                        <span className="redColor ml-2">{amountError}</span>
                      )}
                    </div>

                    <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Payment option
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTCRDC"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTCRDC"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2 mr-2">Credit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTDBCRD"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTDBCRD"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2 mr-2">Debit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTNBK"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTNBK"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2">Net Banking</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTUPI"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTUPI"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2">UPI</label>
                      </div>
                      {error && paymentOptionError && (
                        <span className="redColor ml-2">
                          {paymentOptionError}
                        </span>
                      )}
                    </div>

                    <br />

                    <div
                      className="button-container"
                      style={{ justifyContent: "center" }}
                    >
                      <button
                        className="btn btn-danger btn-lg"
                        onClick={handleSubmit}
                        style={{ width: "250px" }}
                      >
                        Make Payment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentForm;
